export function pharmacyDataSelector({
  tdFlow: {
    formState: {
      save_pharmacy,
      zipCode,
      city,
      state,
      logged_in_member_id,
      searchBy,
      health_category,
      dfdDashboard,
      ...formState
    }
  }
}) {
  return {
    save_pharmacy,
    zipCode,
    city,
    state,
    logged_in_member_id,
    searchBy,
    zipRadius: formState["zipcode.radius"],
    cityRadius: formState["city.radius"],
    locationRadius: formState["currentLocation.radius"],
    health_category,
    dfdDashboard
  };
}

export function screensSelector({
  tdFlow: {
    data: { screens }
  }
}) {
  return screens;
}
